import { render, staticRenderFns } from "./storeHistoryChatPdfPage.vue?vue&type=template&id=20a14fd6&"
import script from "./storeHistoryChatPdfPage.vue?vue&type=script&lang=ts&"
export * from "./storeHistoryChatPdfPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports